/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="./moverTool.controller.ts" />

module Meevo.Plugins.Discounts {
    'use strict';

    export class DiscountsMoverTool implements angular.IDirective {
        restrict = 'E';
        templateUrl = 'app/plugins/discounts/moverTool/moverTool.template.html';
        scope = {
            title: '@',
            buyGetTitle: '@',
            discountEntityType: '=',
            manufacturerId: '=',
            isReadonly: '=',
            isBuyGet: '=',
            tabIndex: '=?',
            changed: '&?'
        };
        bindToController = true;
        controller = Meevo.Plugins.Discounts.DiscountsMoverToolController;
        controllerAs = '$ctrl';
        require = [
            'discountsMoverTool',
            'ngModel'
        ];
        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.ngModel = ngModel;
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new DiscountsMoverTool();
            };

            return directive;
        }
    }
    angular.module('meevo.plugins.discounts')
        .directive('discountsMoverTool', DiscountsMoverTool.factory());
}
